// extracted by mini-css-extract-plugin
export default {"modalSubtitle":"CavaticaCreateProjectModal_modalSubtitle__bxv7D","cavaticaCreateProjectModal":"CavaticaCreateProjectModal_cavaticaCreateProjectModal__wxudF"};